exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jzq-logo[data-v-43afaa74],.jzq-return[data-v-43afaa74]{height:60px}.jzq-logo[data-v-43afaa74]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-size:1.4vw;font-weight:bolder}.jzq-logo img[data-v-43afaa74]{margin:13px}.jzq-return ul[data-v-43afaa74]{padding:0;margin:0;height:100%}.jzq-return ul li[data-v-43afaa74]{display:inline-block;height:100%;line-height:60px}.jzq-return ul li a[data-v-43afaa74]{color:#f0f0f0;padding:0 15px}.jzq-return ul li a[data-v-43afaa74]:hover{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":0,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-43afaa74","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./layouts/digital.vue
// module id = 32y2
// module chunks = 203